import filterQueryBuilder from 'helpers/filterToQuery'
import { requests, mainApiRoot } from './index'

export const Keywords = {
  // Export Keywords
  exportKeywordsExcel: id => requests.getFile(mainApiRoot, `/domains/${id}/keywords/excel`),
  exportKeywordsCSV: id => requests.getFile(mainApiRoot, `/domains/${id}/keywords/csv`),

  // Export Competitors
  exportCompetitorsExcel: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/competitors/excel`),
  exportCompetitorsCSV: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/competitors/csv`),

  // Export Pages
  exportPagesExcel: id => requests.getFile(mainApiRoot, `/domains/${id}/keywords/pages/excel`),
  exportPagesCSV: id => requests.getFile(mainApiRoot, `/domains/${id}/keywords/pages/csv`),

  // Export Metrics
  exportMetricsExcel: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/metrics/excel`),
  exportMetricsCSV: id => requests.getFile(mainApiRoot, `/domains/${id}/keywords/metrics/csv`),

  // Export Grossing
  exportGrossingExcel: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/grossing/excel`),
  exportGrossingCSV: id => requests.getFile(mainApiRoot, `/domains/${id}/keywords/grossing/csv`),

  // Export Discovery
  exportDiscoveryExcel: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/discovery/excel`),
  exportDiscoveryCSV: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/discovery/csv`),

  // Export Savings
  exportSavingsExcel: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/savings/excel`),
  exportSavingsCSV: id => requests.getFile(mainApiRoot, `/domains/${id}/keywords/savings/csv`),

  // Export Notifications
  exportNotificationsExcel: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/notifications/excel`),
  exportNotificationsCSV: id =>
    requests.getFile(mainApiRoot, `/domains/${id}/keywords/notifications/csv`),

  get: (id, filters = {}) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords${query}`)
  },
  getResults: (id, filters = {}) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/results${query}`)
  },
  getChanges: (id, filters = {}) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/changes${query}`)
  },
  getCompetitorsResults: (id, filters = {}) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/competitors/results${query}`)
  },
  getCompetitorsChanges: (id, filters = {}) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/competitors/changes${query}`)
  },
  add: (id, payload) => requests.post(mainApiRoot, `/domains/${id}/keywords`, payload),
  update: (id, payload) => requests.post(mainApiRoot, `/domains/${id}/keywords`, payload),
  history: (domainId, keywordId, filters = {}) => {
    const { startDate, endDate } = filters
    const query = filterQueryBuilder({ startDate, endDate })
    return requests.get(mainApiRoot, `/domains/${domainId}/keywords/${keywordId}/history${query}`)
  },
  serp: (domainId, keywordId) =>
    requests.get(mainApiRoot, `/domains/${domainId}/keywords/${keywordId}/serp`),
  serpHistory: (domainId, keywordId, filters = {}) => {
    const { startDate, endDate } = filters
    const query = filterQueryBuilder({ startDate, endDate })
    return requests.get(
      mainApiRoot,
      `/domains/${domainId}/keywords/${keywordId}/serp-feature-history${query}`
    )
  },
  del: (domainId, payload) => {
    return requests.del(mainApiRoot, `/domains/${domainId}/keywords/batch_destroy`, payload)
  },
  notifications: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/notifications${query}`)
  }
}